import {Fragment} from "react";
import BasicModal from "../../../../../common/BasicModal";
import GorgiasViewsSetupContent from "./GorgiasViewsSetupContent";

export default function GorgiasViewsSetupModal({title, trendsId, open, handleClose}) {

    return (
        <Fragment>
            <BasicModal
                title={title}
                open={open}
                style={{width: '650px'}}
                handleClose={handleClose}>

                {open && (
                    <GorgiasViewsSetupContent
                        trendsId={trendsId}
                        handleClose={handleClose}
                    />
                )}
            </BasicModal>
        </Fragment>
    );
}
